import { useState, useCallback, useEffect } from 'react'
import { Box, useTheme, useMediaQuery } from '@mui/material'
import { observer } from 'mobx-react-lite'
import Header from './Header'
import { useStores } from '../../app/providers/withStore'
import SideBar from './SideBar'
import { StyledMain } from './styles'

const fullDrawerWidth = 325
const miniDrawerWidth = 96

const MainLayout = observer(({ children }) => {
  const { layoutStore } = useStores()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [mobileOpen, setMobileOpen] = useState(false)

  // Эффект для сброса состояния "mini" при переходе на мобильную версию.
  // Это гарантирует, что мобильный сайдбар всегда открывается в полном виде.
  useEffect(() => {
    if (isMobile) {
      if (layoutStore.isMini) {
        layoutStore.toggleMini()
      }
    }
  }, [isMobile, layoutStore])

  const handleDrawerToggle = useCallback(() => {
    setMobileOpen((prev) => !prev)
  }, [])

  const drawerWidth = isMobile
    ? fullDrawerWidth
    : layoutStore.isMini
      ? miniDrawerWidth
      : fullDrawerWidth

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <SideBar
        drawerWidth={drawerWidth}
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      />
      <StyledMain
        component="main"
        sx={{
          flexGrow: 1,
          width: { md: `calc(100% - ${drawerWidth}px)` },
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Header handleDrawerToggle={handleDrawerToggle} />
        <Box sx={{ p: { xs: 2, md: 3 } }}>{children}</Box>
      </StyledMain>
    </Box>
  )
})

export default MainLayout
